import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { TOAST_DURATION } from '@/constants'

export default {
  name: 'IrrigationEditForm',
  components: {
    LayoutBasic
  },
  props: ['id'],
  data () {
    return {
      irrigationEditItem: null,
      mode: 'edit'
    }
  },
  created () {
    if (this.id === 'new') {
      this.mode = 'new'
      this.irrigationEditItem = {
        description: null,
        cost: null,
        defaultQuantity: 1
      }
    } else {
      this.mode = 'edit'
      const item = this.$store.getters.getIrrigationItemById(this.id)
      // just want a local copy for the form
      this.irrigationEditItem = {...item}
    }
  },
  methods: {
    submitForm (evt) {
      evt.preventDefault()

      const jsConn = new JSConn()
      jsConn.toRoutePath = '/irrigation'
      jsConn.formParams = {
        id: this.id,
        item: this.irrigationEditItem
      }

      this.$store.dispatch('updateIrrigationItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
          this.$router.push('/irrigation')
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
